"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRedirectToKeycardActivation = void 0;
const useRedirectToKeycardActivation = ({ data, baseUrl, history }) => {
    history.push({
        pathname: `${baseUrl}/guest_journey/kiosk/keycard_activation`,
        state: {
            inKeycardActivationFromCheckin: true,
            stay: data.stay,
            texts: data.texts,
        },
    });
};
exports.useRedirectToKeycardActivation = useRedirectToKeycardActivation;
